import MRWidgetOptions from 'ee/vue_merge_request_widget/mr_widget_options.vue';

export default MRWidgetOptions;
